





import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"

/**
 * @status stable
 * @published 3.4.0
 * @changelog 3.4.0 Published.
 * @changelog 3.4.1 Added no-wrap.
 * @changelog 3.4.2 Support @click and deselected mode.
 * @changelog 4.17.0 Support unknown score.
 * @changelog 4.17.1 Fix sizing issues.
 */
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsScoreBadge extends Vue {
    @Prop() value!: 'A+' | 'A' | 'B' | 'C' | '?' ;

    /**
     * If you're offering score badges for a filter or toggleable interface, deselect the hidden-away badges.
     */
    @Prop({default: false, type: Boolean}) deselected!: boolean;

    get classes() {
        let classes = [];
        if (this.deselected) {
            classes.push('jdsc-score-deselected');
        }

        if (this.value === 'A+') {
            classes.push('jdsc-score-a-plus')
        } else if (this.value === '?') {
            classes.push('jdsc-score-unknown')
        } else {
            classes.push('jdsc-score-' + this.value.toLowerCase())
        }

        return classes;
    }

    get isClickable() {
        return this.$listeners['click'];
    }

    emitClick (event: MouseEvent) {
        /**
         * Emitted on every user-initiated click.
         * @param {MouseEvent} event
         */
        this.$emit('click', event);
    }
}
